export enum CustomIconName {
  ArrowCircleRight = 'ArrowCircleRight',
}
